<template>
  <section  id="app" class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
      <div class="columns is-mobile is-centered">
        <div class="column is-two-fifths">
          <h1 class="title">Zul Digital Corporate</h1>
          <h2 class="subtitle">Estacionamento Rotativo Digital</h2>

          <div v-if="message" v-html="message" />

          <form v-else-if="token" @submit="redefine">
            <p>Cadastre sua senha</p>
            <br>

            <b-field label="Senha" expanded
              :type="{'is-danger': errors.has('password')}"
              :message="errors.first('password')">
              <b-input type="password" v-model="user.password" name="password" maxlength="50" :has-counter="false"
                v-validate="'required'" data-vv-as="senha" ref="password" password-reveal/>
            </b-field>

            <b-field label="Confirmar senha" expanded
              :type="{'is-danger': errors.has('confirmPassword')}"
              :message="errors.first('confirmPassword')">
              <b-input type="password" v-model="user.confirmPassword" name="confirmPassword" maxlength="50" :has-counter="false"
                v-validate="'required|confirmed:password'" data-vv-as="confirmar senha"/>
            </b-field>

            <b-field grouped>
              <div class="control">
                <b-button type="is-primary" @click="redefine">Definir Senha</b-button>
              </div>
              <div class="control">
                <router-link to="/login" class="button is-text">Voltar</router-link>
              </div>
            </b-field>
          </form>

          <form v-else @submit="request">
            <b-field>
              <b-input v-model="user.userID" placeholder="Documento"/>
            </b-field>

            <b-field grouped>
              <div class="control">
                <b-button type="is-primary" @click="request">Recuperar Senha</b-button>
              </div>
              <div class="control">
                <router-link to="/login" class="button is-text">Voltar</router-link>
              </div>
            </b-field>
          </form>

        </div>
      </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      user: {
        userID: null,
        password: null,
      },
      token: Object.keys(this.$route.query)[0],
      message: null,
    };
  },
  methods: {
    request() {
      this.$http.post(
        this.$auth.options.recoverUrl,
        { userID: this.user.userID },
      ).then((res) => {
        this.message = res.data.message;
      }, (err) => {
        this.$buefy.toast.open({
          message: err.response.data.error.message,
          type: 'is-danger',
        });
      });
    },

    redefine() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http.post(
            this.$auth.options.redefineUrl,
            {
              password: this.user.password,
              token: this.token,
            },
          ).then(() => {
            this.$router.push('/');
          }, (err) => {
            this.$toast.error(err.response.data.error.message);
          });

          return;
        }
        this.$buefy.toast.open({
          message: 'Verfique a senha informada antes de continuar.',
          type: 'is-danger',
        });
      });
    },
  },
};
</script>
